<template>
    <div id="projectViewQuotationDetail">
        <eb-panel>
            <eb-panel-header class="panel-header" slot="header">
                <span slot="title">报价一览</span>
            </eb-panel-header>
            <div slot="body">
                <div class="panel-body-row">
                    <div class="panel-left">
                        <div class="panel-body-row-left">
                            总报价(小写):
                        </div>
                        <div class="panel-body-row-right">
                            {{project.quoteMin| formatCurrency}}
                        </div>
                    </div>
                    <div class="panel-right">
                        <div class="panel-body-row-left">
                            总报价(大写):
                        </div>
                        <div class="panel-body-row-right">
                            {{project.quoteMin| formatCurrencyCny}}
                        </div>
                    </div>
                </div>
                <div class="panel-body-row quoteStatement">
                    <div class="panel-body-row-left">
                        报&ensp;价&ensp;说&ensp;明:
                    </div>
                    <div class="panel-body-row-right">
                        <pre>{{project.quoteStatement||'-'}}</pre>
                    </div>
                </div>
                <div class="panel-body-row">
                    <div class="panel-left">
                        <div class="panel-body-row-left">
                            报&ensp;价&ensp;时&ensp;间:
                        </div>
                        <div class="panel-body-row-right">
                            {{project.quoteTime| dateTimeStandardFormatZh}}
                        </div>
                    </div>
                    <div class="panel-right">
                        <div class="panel-body-row-left">
                            报价IP地址:
                        </div>
                        <div class="panel-body-row-right">
                            {{project.quoteIP||'-'}}
                        </div>
                    </div>
                </div>
            </div>
        </eb-panel>
    </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
export default {
  name: 'projectViewQuotationDetail',
  props: {
    project: {}
  },
  components: {
    ebPanel,
    ebPanelHeader
  }
};
</script>
<style scoped lang="less">
#projectViewQuotationDetail {
  .panel-left,
  .panel-right {
    display: flex;
    flex: 1;
  }
  .quoteStatement{
      .panel-body-row-left{
          width:11.5%;
      }
      .panel-body-row-right{
          width:88.5%;
      }
  }
}
</style>
